import { composeRenderProps, ToggleButton, type ToggleButtonProps } from "react-aria-components";
import { tv, type VariantProps } from "tailwind-variants";

const toggleVariants = tv({
  base: "inline-flex items-center justify-center gap-2 rounded-md text-sm font-medium hover:bg-muted hover:text-muted-foreground disabled:pointer-events-none disabled:opacity-50 data-[selected]:bg-foreground data-[selected]:text-background [&_svg]:pointer-events-none [&_svg:not([class*='size-'])]:size-4 [&_svg]:shrink-0 focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] outline-none transition-[color,box-shadow] aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive whitespace-nowrap",
  variants: {
    variant: {
      default: "bg-transparent",
      outline:
        "border border-input bg-transparent shadow-xs hover:bg-accent hover:text-accent-foreground"
    },
    size: {
      default: "h-9 px-2 min-w-9",
      sm: "h-8 px-1.5 min-w-8",
      lg: "h-10 px-2 min-w-10",
      xl: "h-11 px-3 min-w-12"
    }
  },
  defaultVariants: {
    variant: "default",
    size: "default"
  }
});

type ToggleVariants = VariantProps<typeof toggleVariants>;

type ToggleProps = ToggleButtonProps & ToggleVariants;

function Toggle({ variant, size, className, ...props }: ToggleProps) {
  return (
    <ToggleButton
      data-slot="toggle"
      className={composeRenderProps(className, innerClassName =>
        toggleVariants({ variant, size, className: innerClassName })
      )}
      {...props}
    />
  );
}

export { Toggle, toggleVariants };
